import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSun, FiMoon, FiMonitor } = FiIcons;

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  const themes = [
    { id: 'light', icon: FiSun, label: 'Light' },
    { id: 'system', icon: FiMonitor, label: 'System' },
    { id: 'dark', icon: FiMoon, label: 'Dark' }
  ];

  return (
    <div className="flex items-center space-x-1 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
      {themes.map((themeOption) => (
        <motion.button
          key={themeOption.id}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setTheme(themeOption.id)}
          className={`p-2 rounded-md transition-all duration-200 ${
            theme === themeOption.id
              ? 'bg-white dark:bg-gray-600 shadow-sm text-blue-600 dark:text-blue-400'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
          }`}
          title={themeOption.label}
        >
          <SafeIcon icon={themeOption.icon} className="w-4 h-4" />
        </motion.button>
      ))}
    </div>
  );
};

export default ThemeToggle;